import React, { useState } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { authLogin, customerLogin } from "../../../apis/auth";
type PasswordField = "password";

const CustomerLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordVisibility, setPasswordVisibility] = useState({ password: false });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const navigationPath = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!username || !password) return;


    setLoading(true);
    try {
      const response = await customerLogin({ username, password });
      if (response.status === true) {
        const userinfo = {
          user_id: response?.data?.id,
          id: response?.data?.vendor_id,
          type: response?.data?.type,
          username: response?.data?.username,
          aadharNumber: response?.data?.aadharNumber,
          prefix: response?.data?.prefix_code,
          permission: response?.data?.permissions
        };

        const routes = response?.data?.permitted_routes;

        sessionStorage.setItem("info", JSON.stringify(userinfo));
        sessionStorage.setItem("mat", JSON.stringify(userinfo));
        sessionStorage.setItem("routes", JSON.stringify(routes));
        sessionStorage.setItem("plan", JSON.stringify(response?.data?.plan));
        sessionStorage.setItem("token", response?.token);
        setLoading(false);
        const userType = response?.data?.type;
        if (userType === "financer") {
          window.location.href = "/employee-dashboard";
        } else if (userType === "customer") {
          window.location.href = "/emis-records";
        } else {
          window.location.href = "/index";
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div className="container-fuild">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block ">
        <div className="row">
          <div className="col-lg-5">
            <div className="login-background position-relative d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100">
              <div className="bg-overlay-img">
                <ImageWithBasePath src="assets/img/bg/bg-01.png" className="bg-1" alt="Img" />
                <ImageWithBasePath src="assets/img/bg/bg-02.png" className="bg-2" alt="Img" />
                <ImageWithBasePath src="assets/img/bg/bg-03.png" className="bg-3" alt="Img" />
              </div>
              <div className="authentication-card w-100">
                <div className="authen-overlay-item border w-100">
                  <h1 className="text-white display-1">
                    Fueling Retail Growth with Smart NSSOFT TECH Finance Solutions
                  </h1>
                  <div className="my-4 mx-auto authen-overlay-img">
                    <ImageWithBasePath
                      src="assets/img/bg/authentication-bg-01.png"
                      alt="Img"

                    />
                  </div>
                  <div>
                    <p className="text-white fs-20 fw-semibold text-center">
                      Efficiently manage your workforce, streamline <br />{" "}
                      operations effortlessly.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12 h-300" >
            <div className="row justify-content-center align-items-center  overflow-auto flex-wrap">
              <div className="col-md-7 mx-auto ">
                <form className="">
                  <div className=" d-flex flex-column justify-content-around p-4 pb-0">
                    <div className=" mx-auto mb-5 text-center">
                      <ImageWithBasePath
                        src="assets/logo1.png"
                        className="img-fluid"
                        alt="Logo"
                        width={100}
                        height={100}
                      />
                    </div>
                    <div className="">
                      <div className="text-center mb-3">
                        <h2 className="mb-2">Customer Sign In</h2>
                        <p className="mb-0">
                          Please enter your details to sign in
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">User Name</label>
                        <div className="input-group">
                          <input
                            type="text"
                            onChange={(e) => setUsername(e.target.value)}
                            value={username}
                            defaultValue=""
                            className="form-control border-end-0"
                          />
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <div className="pass-group">
                          <input
                            type={
                              passwordVisibility.password ? "text" : "password"
                            }
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            className="pass-input form-control"
                          />
                          <span
                            className={`ti toggle-passwords ${passwordVisibility.password
                              ? "ti-eye"
                              : "ti-eye-off"
                              }`}
                            onClick={() => togglePasswordVisibility("password")}
                          ></span>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">

                        <div className="text-end">
                          <Link
                            to={all_routes.forgotPassword}
                            className="link-danger"
                          >
                            Forgot Password?
                          </Link>
                        </div>
                        <div className="text-end">
                          <Link
                            to={all_routes.login}
                            className="link-stander"
                          >
                            Login to Company
                          </Link>
                        </div>
                      </div>
                      <div className="mb-3">
                        {!loading ?
                          <button
                            onClick={navigationPath}
                            type="submit"
                            className="btn btn-primary w-100"
                          >
                            Sign In
                          </button> : <div className="text-center mt-2">
                            <div className="spinner-border text-primary" role="status" />
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerLogin;
